import { Box } from '@chakra-ui/react';
import Line from 'images/backgrounds/inventory-definition-doodle-line.svg';

import { GradientBackground } from '@/components/atoms';
import { GradientBackgroundProps } from '@/utils/models/background-props';

export const InventoryDefinitionBackground = ({ isInView }: GradientBackgroundProps) => {
  return (
    <>
      <Box
        position="absolute"
        right="0"
        left="0"
        top="0"
        bottom="0"
        zIndex="-2"
        sx={{
          '& > svg': {
            base: {
              position: 'absolute',
              width: '372px',
              height: '293px',
              top: '80px',
              left: '50%',
              transform: 'translateX(-50%)',
            },
            sm: {
              width: '479px',
              height: '378px',
              left: '55%',
            },
            '2xl': {
              left: '52%',
            },
          },
        }}
      >
        <Line />
      </Box>
      <GradientBackground
        isInView={isInView}
        filter="blur(104px)"
        position="absolute"
        right="0"
        bottom="0"
        w={{ base: '650px' }}
        h={{ base: '650px' }}
        zIndex="-2"
      />
    </>
  );
};
